// extracted by mini-css-extract-plugin
export default {"NotFound":"style_NotFound__3b4B7","button":"style_button__6BWKR"};